import { ProductModal } from '../../product/modal/product-modal';
import { PHModal } from '../../ph/modal/phmodal';
import { Puritymodal } from '../../purity/modal/puritymodal';
import { SolubilityModal } from '../../solubility/modal/solubility-modal';
import { MoistureModal } from '../../moisture/modal/moisture-modal';
import { SalesOrderQualityParamDetailsModel } from './sales-order-quality-param-details.model';
import { PackingModel } from '../../packing/model/packing-model';
import { PackingDetailModel } from '../../packing/model/packing-detail-model';
import { PartyModal } from '../../party/modal/party-modal';
import { ItemProperties } from '../../funnel/modal/funnel-modal';
import { ProductionBatchOptimisedModal } from '../../production-batch/model/production-batch.model';

export class SoDetailModal {
  id: number;
  setNo: string;
  item: ProductModal;
  ph: PHModal;
  moisture: MoistureModal;
  solubility: SolubilityModal;
  purity: Puritymodal;
  price: number;
  weight: number;
  pack: any;
  packingType: number;
  packingCapacityDetails: number;
  packedQuantity: number;
  salesOrderQualityParamDetails: Array<SalesOrderQualityParamDetailsModel>;
  details: any;
  totalAvlStock:number = 0;
  productionQty:number=0;
  discount: number = 0;
  receivedSecondaryQuantity: number;
  conversionFactor: number;

  // Angular Use [Dhairya]
  selectedPacking: PackingModel;
  selectedPackageCapacity: PackingDetailModel;
  itemProperties: Array<ItemProperties>;
  gst: number;
  noOfPackages: number = 1;
  remark: string;
  itemTupleId: number;
  
  // Label as a Product #DK15102020
  isSet = false;
  isLabelProduct = true;
  customerLabel: ProductModal;
  customer: PartyModal;
  finalAmout: number;
  gstAmount: number;
  taxableAmount: number;
  mrp: number;
  itemProp: Array<ItemProperties>;
  totalAmt: number = 0;
  finalAmt: number = 0;
  totalDiscount: number = 0;

  //For Dispatch Stock
  optimizedData: Array<ProductionBatchOptimisedModal>;
  dispatchedQuantity: number;
  remainingDispatchQty: number;
}
